<section class="detail-page">

  @if (model) {

    <!-- Header -->
    <header class="detail-header">
      <button class="back-btn" type="button" (click)="goToProperties()" aria-label="Back to properties">
        <mat-icon fontIcon="arrow_back"></mat-icon>
      </button>

      <div class="detail-header__identity">
        <span class="detail-header__icon">
          <mat-icon [svgIcon]="icons.HomeOutlineIcon"></mat-icon>
        </span>
        <div>
          <div class="detail-header__eyebrow">Property ID</div>
          <h1 class="detail-header__title">
            <span class="detail-header__id">#{{ model.rentalPropertyInfo.id }}</span>
            <span class="detail-header__sep">·</span>
            <span class="detail-header__addr">{{ model.rentalPropertyInfo.rentalPropertyStreetAddress }}</span>
          </h1>
        </div>
      </div>

      <div class="detail-header__meta">
        <div class="meta-item">
          <span class="meta-item__icon">
            <mat-icon [svgIcon]="icons.NewEventAvailable"></mat-icon>
          </span>
          <div class="meta-item__text">
            <span class="meta-item__label">Creation date</span>
            <span class="meta-item__value">{{ model.rentalPropertyInfo.createdDate | date: 'MMM d, yyyy' }}</span>
          </div>
        </div>

        <div class="meta-divider"></div>

        <div class="meta-item">
          <span class="meta-item__icon">
            <mat-icon [svgIcon]="icons.NewTraffic"></mat-icon>
          </span>
          <div class="meta-item__text">
            <span class="meta-item__label">Status</span>
            <span class="status-pill"
                  [class.status-pill--active]="model.rentalPropertyInfo.status === 'ACTIVE'">
              <span class="status-pill__dot"></span>
              {{ model.rentalPropertyInfo.statusDescription }}
            </span>
          </div>
        </div>
      </div>
    </header>

    <!-- Tabs -->
    <div class="detail-card">
      <mat-tab-group #tabGroup (selectedIndexChange)="onTabChange($event)" class="detail-tabs">
        <mat-tab label="PROPERTY">
          <div class="tab-body">
            <app-properties-detail-info (formChanged)="formHasChanges($event)"
              [rentalPropertyModel]="model.rentalPropertyInfo"
              #propertiesDetailInfoComponent></app-properties-detail-info>
          </div>
        </mat-tab>

        <mat-tab *ngIf="externalUser?.accountType != 3"
                 [label]="externalUser?.accountType == 1 ? 'OWNERS' : 'OWNER'">
          <div class="tab-body">
            <app-properties-detail-owners *ngIf="externalUser?.accountType == 1"
              (formChanged)="formHasChanges($event)" #propertiesDetailOwnersComponent
              [rentalProperty]="model.rentalPropertyInfo"
              [dataOwners]="model.owners"></app-properties-detail-owners>

            <app-properties-single-owner *ngIf="externalUser?.accountType == 2"
              (formChanged)="formHasChanges($event)" #propertiesSingleOwnerComponent
              [dataOwners]="model.owners"></app-properties-single-owner>
          </div>
        </mat-tab>

        <mat-tab *ngIf="externalUser?.accountType != 2" label="REPORTING">
          <div class="tab-body">
            <app-properties-detail-reporting (formChanged)="formHasChanges($event)"
              #propertiesDetailReportingComponent [companies]="model.companies"
              [taxRepresentative]="model.taxRepresentative"
              [rentalPropertyModel]="model.rentalPropertyInfo"></app-properties-detail-reporting>
          </div>
        </mat-tab>

        <mat-tab label="LICENSES">
          <div class="tab-body">
            <app-properties-detail-license [rentalProperty]="model.rentalPropertyInfo"
              #propertiesDetailLicense (formChanged)="formHasChanges($event)"
              [rentalPropertyLicenseModel]="model.rentalPropertyLicense"></app-properties-detail-license>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <!-- Fixed action bar -->
    <div class="detail-actions">
      <div class="detail-actions__inner">
        <button *ngIf="model.rentalPropertyInfo.status == 'ACTIVE'" (click)="printReport()"
                mat-stroked-button color="primary" type="button">
          <mat-icon>print</mat-icon> Certificate of registration
        </button>
        <button *ngIf="model.rentalPropertyInfo.status == 'ACTIVE'" (click)="openDeactivateModal()"
                mat-stroked-button color="warn" type="button">
          <mat-icon>pause_circle</mat-icon> Inactivate property
        </button>
        <span class="detail-actions__spacer"></span>
        <button [disabled]="!hasChanges" (click)="save()" mat-flat-button color="primary" type="button">
          <mat-icon>save</mat-icon> Save changes
        </button>
      </div>
    </div>

  } @else {
    <div class="detail-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading property…</p>
    </div>
  }

</section>
